import { render, staticRenderFns } from "./ReportCardTableView.vue?vue&type=template&id=bc595a6c&scoped=true"
import script from "./ReportCardTableView.vue?vue&type=script&lang=js"
export * from "./ReportCardTableView.vue?vue&type=script&lang=js"
import style0 from "./ReportCardTableView.vue?vue&type=style&index=0&id=bc595a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc595a6c",
  null
  
)

export default component.exports